<template>
  <div class="labelling-setting h100">
    <div class="h100 y-auto">
      <div class="head-title">
        <span id="span_00mvc6dhxk">{{
          $t('cuttingDock.labelingSettings.output')
        }}</span>
        <a-switch
          :checked="formData.labelingMachine"
          id="engraving_setting_labelMachine_switch"
          style="margin-left: 68px"
          @change="handleChangeLabelingMachineStatus"
        ></a-switch>
      </div>
      <div v-if="formData.labelingMachine">
        <div class="label-file-format mt16">
          <span id="span_14540bfis1" class="head-title">{{
            $t('cuttingDock.labelingSettings.specification')
          }}</span>
          <!-- <div class="radio-box">
            <a-radio-group v-model="formData.labelFormat">
              <a-radio v-for="(item, index) in fileFormatList" :key="index" :value="item.value">{{ item.name }}</a-radio>
            </a-radio-group>
          </div> -->
          <div class="radio-box" style="position: relative">
            <span id="span_y1z2g0ap4e" class="base-title-label"
              >{{ $t('cuttingDock.labelingSettings.specification') }}：</span
            >
            <a-select
              style="width: 280px"
              v-model="formData.labelFormat"
              @change="changeLabelingFormat"
              id="engraving_setting_labelFormat_select"
              show-search
              showArrow
              :getPopupContainer="
                (triggerNode) => {
                  return triggerNode.parentNode || document.body
                }
              "
              :filter-option="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .trim()
                    .includes(input.toLowerCase())
              "
            >
              <a-select-option
                v-for="(label, index) in allLabelingList"
                :key="label.labelFormat"
                :value="label.labelFormat"
                :id="`engraving_setting_labelFormat_option_${index}`"
                :title="label.modelName"
                class="all-labeling"
              >
                {{ label.modelName }}
              </a-select-option>
            </a-select>
            <span
              id="span_unjx888dwq"
              v-if="labelNotOnline"
              class="not-online-info"
              >{{ $t('cuttingDock.labelingSettings.templateOffline') }}</span
            >
          </div>
        </div>
        <div class="auto-feeding-box">
          <span id="span_epdpv6ywja" class="base-title-label"
            >{{ $t('cuttingDock.labelingSettings.codeFrontGenerate') }}：</span
          ><a-switch
            v-model="formData.label_after_send_stock"
            id="engraving_setting_label_after_send_stock_checkbox"
          ></a-switch>
        </div>
        <!-- 自动贴标设置 -->
        <div class="auto-label-setting">
          <div class="flex title">
            <span id="span_46wjq3wmip" class="fs20 color-0 bold">{{
              $t('cuttingDock.labelingSettings.autolabel')
            }}</span>
            <span
              id="span_4xsqnu98s3"
              class="inline-block ml10 auto-label-tip fs16 color-o-4"
              >({{ $t('cuttingDock.labelingSettings.customTemp') }})</span
            >
          </div>
          <div style="padding: 18px 24px 24px 24px">
            <span id="span_sqzb8nnw8o" class="base-title-label"
              >{{ $t('cuttingDock.labelingSettings.autolabel') }}：</span
            >
            <a-select
              style="width: 280px"
              v-model="formData.labelingOrder"
              @change="handleChangeRadio"
              id="engraving_setting_label_sort_select"
              showArrow
            >
              <a-select-option
                v-for="(item, index) in labelingOrderList"
                :key="item.value"
                :value="item.value"
                :id="`engraving_setting_label_sort_option_${index}`"
              >
                {{ $t(item.label) }}
              </a-select-option>
            </a-select>
          </div>
        </div>
        <!-- 孔槽避让 -->
        <div class="flex labeling-dodge">
          <span
            id="span_wwkz940oze"
            class="fs20 color-o-9 bold"
            style="margin-right: 124px"
            >{{ $t('cuttingDock.labelingSettings.labelDodge') }}</span
          >
          <a-switch
            v-model="formData.labelingDodge"
            id="engraving_setting_dodge_switch"
          ></a-switch>
        </div>
        <!-- 余料大板不生成贴标文件 -->
        <div class="flex labeling-dodge">
          <span id="span_x3gtchcd91" class="fs18 color-0 bold mr16">{{
            $translateLang('余料大板不生成贴标文件')
          }}</span>
          <a-switch
            style="margin-left: 28px"
            v-model="formData.no_gen_labelling_file_to_surplus"
            id="engraving_setting_nolabelForsurplus_switch"
          ></a-switch>
        </div>
        <div>
          <span id="span_co1fr2qi85" class="head-title labeling-setting">{{
            $t('cuttingDock.labelingSettings.rollLabelling')
          }}</span>
          <div class="auto-feeding-box flex">
            <span id="span_zyarksyl4r" class="base-title-label"
              >{{
                $t(
                  'cuttingDock.labelingSettings.flipSetting.engravingFlipProcess'
                )
              }}：</span
            >
            <div class="flex flex-dir--top">
              <a-switch
                v-model="formData.labelOverturn"
                id="engraving_setting_labelOverturn_switch"
                style="width: 44px"
              ></a-switch>
              <i id="i_m5ivnls4di" class="tip mt4 fs14">{{
                $t('cuttingDock.labelingSettings.flipSetting.flipTip')
              }}</i>
            </div>
          </div>
        </div>
        <div class="tag-setting">
          <span id="span_1imdfm5un8" class="head-title"
            >{{ $t('cuttingDock.labelingSettings.rotateSetting.title') }}
            <i id="i_ypoq9w301n" class="tip ml10"
              >({{
                $t('cuttingDock.labelingSettings.rotateSetting.rotateTip')
              }})</i
            >
          </span>
          <div style="padding: 18px 24px 24px 24px">
            <div class="flex">
              <span id="span_yxmr16hotn" class="base-title-label">
                {{ $t('cuttingDock.labelingSettings.settingValue') }}：
              </span>
              <div class="flex flex-dir--top">
                <a-switch
                  v-model="formData.rotateLabelSetting.rotateLabel"
                  id="engraving_setting_rotateLabel_switch"
                  style="width: 44px"
                ></a-switch>
                <i id="i_pou5qlgatt" class="color-o-4 mt4">
                  {{ $t('cuttingDock.labelingSettings.enabelTip') }}
                </i>
                <div
                  v-show="
                    isShowSecondaryCatalog ||
                    formData.rotateLabelSetting.rotateLabel
                  "
                  style="margin-top: 24px"
                >
                  <a-select
                    style="width: 160px"
                    v-model="formData.rotateLabelSetting.horizontal"
                    :disabled="!formData.rotateLabelSetting.rotateLabel"
                    id="engraving_setting_horizontal_select"
                    showArrow
                  >
                    <a-select-option
                      v-for="(item, index) in horizontalList"
                      :key="item.value"
                      :value="item.value"
                      :id="`engraving_setting_horizontal_option_${index}`"
                    >
                      {{ $t(item.label) }}
                    </a-select-option>
                  </a-select>
                  <span class="ph10">≤</span>
                  <a-input
                    suffix="mm"
                    ref="rotateInput"
                    id="engraving_setting_rotateLabelSetting_criticalValue_input"
                    @change="
                      checkInout(
                        formData.rotateLabelSetting.criticalValue,
                        formData,
                        ['rotateLabelSetting', 'criticalValue'],
                        '4-2',
                        '0.01'
                      )
                    "
                    v-model="formData.rotateLabelSetting.criticalValue"
                    :disabled="!formData.rotateLabelSetting.rotateLabel"
                    style="width: 138px"
                  ></a-input>
                </div>
                <div
                  class="pt10"
                  v-show="
                    isShowSecondaryCatalog ||
                    formData.rotateLabelSetting.rotateLabel
                  "
                >
                  <img src="@/assets/tagRota1.png" alt="加载错误" />
                </div>
              </div>
            </div>
            <div class="flex" style="margin-top: 32px">
              <span id="span_k8ju2j44ge" class="base-title-label">
                {{ $t('cuttingDock.labelingSettings.fixedHori') }}：
              </span>
              <div class="flex flex-dir--top">
                <a-switch
                  v-model="formData.lable_parallel_setting.parallel_plank"
                  id="engraving_setting_parallelPlank_switch"
                  style="width: 44px"
                ></a-switch>
                <!-- <i class="fs14 color-o-4 mt4">
                  {{ $t('cuttingDock.labelingSettings.fixedHoriTip') }}
                </i> -->
                <span
                  id="span_9uzktw6r67"
                  class="parallel-effective"
                  v-show="
                    isShowSecondaryCatalog ||
                    formData.lable_parallel_setting.parallel_plank
                  "
                  >{{ $translateLang('生效对象') }}:
                  <a-select
                    class="ml8"
                    v-model="formData.lable_parallel_setting.effective_object"
                    :disabled="!formData.lable_parallel_setting.parallel_plank"
                    style="width: 180px"
                  >
                    <a-select-option
                      id="a_select_option_6odj5ruupu"
                      value="notcare"
                      >{{ $translateLang('仅无纹理小板') }}</a-select-option
                    >
                    <a-select-option
                      id="a_select_option_oz63aihidw"
                      value="all"
                      >{{ $translateLang('所有小板') }}</a-select-option
                    >
                  </a-select>
                </span>
                <span
                  id="span_rfu7mry8fo"
                  class="head-title"
                  style="padding: 10px 0; font-weight: 400; font-size: 14px"
                  v-show="
                    isShowSecondaryCatalog ||
                    formData.lable_parallel_setting.parallel_plank
                  "
                >
                  {{ $t('cuttingDock.labelingSettings.tagHori') }}=
                  <a-select
                    style="width: 180px"
                    v-model="formData.lable_parallel_setting.parallel_approach"
                    @change="changeLabelingFormat"
                    id="engraving_setting_tagHorSide_select"
                    class="ml8"
                    showArrow
                    :disabled="!formData.lable_parallel_setting.parallel_plank"
                  >
                    <a-select-option
                      v-for="(item, index) in tagHorSideArr"
                      :key="item.value"
                      :value="item.value"
                      :id="`engraving_setting_tagHorSide_option_${index}`"
                    >
                      {{ $t(item.label) }}
                    </a-select-option>
                  </a-select>
                </span>
                <div
                  class="pt10"
                  v-show="
                    isShowSecondaryCatalog ||
                    formData.lable_parallel_setting.parallel_plank
                  "
                >
                  <img src="@/assets/tagSign1.png" alt="加载错误" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="XYZ-offset">
          <span id="span_azmdrl13or" class="head-title">{{
            $t('cuttingDock.labelingSettings.countertopSetting.title')
          }}</span>
          <div class="XYZ-offset-box">
            <div class="x-point flex">
              <span id="span_h48yj62foq" class="base-title-label"
                >{{
                  $t(
                    'cuttingDock.labelingSettings.countertopSetting.startPoint'
                  )
                }}：</span
              >
              <div>
                <div class="flex flex-cross--center">
                  <m-machine-pos
                    :position="labelingStartPosition"
                    @onPositionChange="handleChangeStartPos"
                    idKey="labelingSetting"
                  >
                  </m-machine-pos>
                  <span class="ml8 color-o-4">{{
                    labelingStartPositionTip
                  }}</span>
                </div>
                <div
                  id="div_jraxks6xfd"
                  class="mt5 mb5"
                  style="color: rgba(0, 0, 0, 0.4)"
                >
                  {{ $t('preLayoutSetting.click')
                  }}<span
                    style="
                      display: inline-block;
                      width: 12px;
                      height: 12px;
                      flex-shrink: 0;
                      background: #d9d9d9;
                    "
                  ></span
                  >{{ $t('preLayoutSetting.grayStart') }}，<span
                    style="
                      display: inline-block;
                      width: 12px;
                      height: 12px;
                      flex-shrink: 0;
                      background: #18a8c7;
                    "
                  ></span
                  >{{ $t('preLayoutSetting.currentStart') }}
                </div>
              </div>
            </div>
          </div>
          <div class="XYZ-offset-box">
            <div class="x-point">
              <span id="span_bcsjn6e1uo" class="base-title-label"
                >{{
                  $t(
                    'cuttingDock.labelingSettings.countertopSetting.baseExchange'
                  )
                }}：</span
              >
              <a-checkbox
                v-model="formData.labelingCountertopSetting.xDatumSwap"
                id="engraving_setting_xDatumSwap_checkbox"
                ><span id="engraving_setting_xDatumSwap_checkbox_label">{{
                  $t('cuttingDock.labelingSettings.countertopSetting.exchangeX')
                }}</span></a-checkbox
              >
              <a-checkbox
                v-model="formData.labelingCountertopSetting.yDatumSwap"
                id="engraving_setting_yDatumSwap_checkbox"
                ><span id="engraving_setting_yDatumSwap_checkbox_label">{{
                  $t('cuttingDock.labelingSettings.countertopSetting.exchangeY')
                }}</span></a-checkbox
              >
            </div>
          </div>
        </div>
        <div class="XYZ-offset">
          <span id="span_k11nd12nzh" class="head-title">{{
            $t('cuttingDock.labelingSettings.offset')
          }}</span>
          <div class="XYZ-offset-box" style="align-items: normal">
            <span
              id="span_x56b0h815x"
              class="base-title-label mt5"
              style="color: rgba(0, 0, 0, 0.9)"
              >{{ $t('cuttingDock.labelingSettings.offset') }}：</span
            >
            <div>
              <div class="flex">
                <div class="x-point">
                  <span>X：</span>
                  <a-input
                    :placeholder="$t('common.inputPlaceholder')"
                    v-model="formData.labelXOffset"
                    id="engraving_setting_labelXOffset_input"
                  ></a-input>
                </div>
                <div class="y-point">
                  <span>Y：</span>
                  <a-input
                    :placeholder="$t('common.inputPlaceholder')"
                    v-model="formData.labelYOffset"
                    id="engraving_setting_labelYOffset_input"
                  ></a-input>
                </div>
              </div>
              <span id="span_zatg0qw7vr" class="color-o-4 mt4 inline-block">{{
                $t('cuttingDock.labelingSettings.offsetTip')
              }}</span>
            </div>
          </div>
        </div>
        <!-- 标签旋转偏移 -->
        <div class="XYZ-offset">
          <div class="flex labeling-dodge">
            <span id="span_tdl8o0rcez" class="fs20 color-0 bold mr16">{{
              $t('cuttingDock.labelingSettings.label_rotate_offset')
            }}</span>
            <a-switch
              v-model="formData.offsetAfterLabelRotation"
              id="labelling_setting_tagRotateOffset_switch"
              style="margin-right: 10px; margin-left: 48px"
            ></a-switch>
            <span id="span_bew0lq3hvx" class="color-o-4"
              >({{
                $t('cuttingDock.labelingSettings.label_rotate_offset_tip')
              }})</span
            >
          </div>
          <div
            v-show="formData.offsetAfterLabelRotation"
            class="XYZ-offset-box pb4"
          >
            <span
              id="span_yxbkwr6sve"
              class="base-title-label mt2"
              style="color: rgba(0, 0, 0, 0.9)"
              >{{
                $t('cuttingDock.labelingSettings.label_rotate_offset')
              }}：</span
            >
            <div class="x-point">
              <span>X：</span>
              <a-input
                :placeholder="$t('common.inputPlaceholder')"
                v-model="formData.xOffsetAfterLabelRotation"
                id="engraving_setting_xOffsetAfterLabelRotation_input"
              ></a-input>
            </div>
            <div class="y-point">
              <span>Y：</span>
              <a-input
                :placeholder="$t('common.inputPlaceholder')"
                v-model="formData.yOffsetAfterLabelRotation"
                id="engraving_setting_yOffsetAfterLabelRotation_input"
              ></a-input>
            </div>
          </div>
          <span
            id="span_3k9si996r9"
            v-show="checkTagRotateOffset"
            style="margin-left: 267px; color: red"
          >
            {{ $t('cuttingDock.labelingSettings.label_rotate_offset_err_tip') }}
          </span>
        </div>
      </div>
      <div class="paiban-image" v-if="formData.labelingMachine">
        <span id="span_hhfj9hs8sv" class="head-title"
          >{{ $t('cuttingDock.labelingSettings.paibanImgSetting.title') }}
          <span id="span_o5ao6ww9em" class="paiban-tip"
            >({{
              $translateLang(
                '开启了导出自定义排版图，下方固定模板不可导出，如需导出请在排版页更多设置里面关闭导出自定义排版图'
              )
            }})</span
          >
        </span>
        <div class="auto-arrange-umber">
          <span id="span_1ov849p62h" class="base-title-label"
            >{{
              $t('cuttingDock.labelingSettings.paibanImgSetting.reparation')
            }}：</span
          >
          <a-input-number
            id="labellingSetting_autoArrangeNumber_input"
            v-model="formData.layoutImageSetting.num_auto_offset"
            :min="1"
            :max="99"
            :disabled="preferencesSetting.setting.isCustomPaibanImg"
          ></a-input-number>
          <span id="span_caytyk912e">{{
            $t('cuttingDock.labelingSettings.paibanImgSetting.figure')
          }}</span>
          <p id="p_6fvaz3icvb" class="color-a mt4" style="margin-left: 246px">
            {{ $t('cuttingDock.labelingSettings.paibanImgSetting.inputTip') }}
          </p>
        </div>
        <div class="paiban-image-box">
          <div
            v-for="(item, index) in formData.layoutImageSetting.layoutImage"
            :key="index"
          >
            <div class="paiban-form-item">
              <span id="span_608xkd3bi1" class="base-title-label"
                >{{
                  $t(
                    'cuttingDock.labelingSettings.paibanImgSetting.paibanImg.export'
                  )
                }}{{ index + 1 }}：</span
              >
              <div>
                <a-checkbox
                  v-model="item.enable"
                  :id="`labellingSetting_enable_checkbox_${index}`"
                  class="mb16"
                  :disabled="preferencesSetting.setting.isCustomPaibanImg"
                ></a-checkbox>
                <div v-show="isShowSecondaryCatalog || item.enable">
                  <div class="paiban-form-item paiban-before">
                    <span id="span_c7qasrks41" class="title">{{
                      $t(
                        'cuttingDock.labelingSettings.paibanImgSetting.paibanImg.prefix'
                      )
                    }}</span>
                    <a-input
                      v-model="item.imageNamePrefix"
                      :max="20"
                      :id="`labellingSetting_imageNamePrefix_input_${index}`"
                      :disabled="preferencesSetting.setting.isCustomPaibanImg"
                    ></a-input>
                  </div>
                  <div class="paiban-form-item paiban-size">
                    <span id="span_z4aypqn1bx" class="title">{{
                      $t(
                        'cuttingDock.labelingSettings.paibanImgSetting.paibanImg.size'
                      )
                    }}</span>
                    <div>
                      <a-input
                        v-model="item.imageSize[0]"
                        @input="paibanImgLimit(item, 0)"
                        :id="`labellingSetting_paibanImgLimit0_input_${index}`"
                        :disabled="preferencesSetting.setting.isCustomPaibanImg"
                      ></a-input>
                      X
                      <a-input
                        v-model="item.imageSize[1]"
                        @input="paibanImgLimit(item, 1)"
                        :id="`labellingSetting_paibanImgLimit1_input_${index}`"
                        :disabled="preferencesSetting.setting.isCustomPaibanImg"
                      ></a-input>
                    </div>
                  </div>
                  <div class="paiban-form-item">
                    <span id="span_6jss1yxei3" class="title">{{
                      $t(
                        'cuttingDock.labelingSettings.paibanImgSetting.paibanImg.format'
                      )
                    }}</span>
                    <a-radio-group
                      v-model="item.imageFormat"
                      :disabled="preferencesSetting.setting.isCustomPaibanImg"
                    >
                      <a-radio
                        value="jpg"
                        :id="`labellingSetting_imageFormat_jpg_radio_${index}`"
                        >jpg</a-radio
                      >
                      <a-radio
                        value="bmp"
                        :id="`labellingSetting_imageFormat_bmp_radio_${index}`"
                        >bmp</a-radio
                      >
                    </a-radio-group>
                  </div>
                  <div class="paiban-form-item" v-if="item.way != 3">
                    <span id="span_jax9yesg2j" class="title">{{
                      $t(
                        'cuttingDock.labelingSettings.paibanImgSetting.paibanImg.directional'
                      )
                    }}</span>
                    <a-radio-group
                      v-model="item.imageDirection"
                      :disabled="preferencesSetting.setting.isCustomPaibanImg"
                    >
                      <a-radio
                        value="vert"
                        :id="`labellingSetting_imageDirection_vert_radio_${index}`"
                        >{{
                          $t(
                            'cuttingDock.labelingSettings.paibanImgSetting.paibanImg.vertical'
                          )
                        }}</a-radio
                      >
                      <a-radio
                        value="horiz"
                        :id="`labellingSetting_imageDirection_horiz_radio_${index}`"
                        >{{
                          $t(
                            'cuttingDock.labelingSettings.paibanImgSetting.paibanImg.horizontal'
                          )
                        }}</a-radio
                      >
                    </a-radio-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="image-format">
        <span id="span_iy93sn90c8" class="head-title">{{
          $t('cuttingDock.labelingSettings.imgSetting.title')
        }}</span>
        <div class="image-format-box">
          <span id="span_cu3gt8r3tu" class="base-title-label">{{
            $t('cuttingDock.labelingSettings.imgSetting.suffix')
          }}</span>
          <a-radio-group v-model="formData.labelImageFormat">
            <a-radio
              value="jpg"
              id="engraving_setting_labelImageFormat_jpg_radio"
              ><span id="engraving_setting_labelImageFormat_jpg_radio_label"
                >jpg</span
              ></a-radio
            >
            <a-radio
              value="bmp"
              id="engraving_setting_labelImageFormat_bmp_radio"
              ><span id="engraving_setting_labelImageFormat_bmp_radio_label"
                >bmp</span
              ></a-radio
            >
            <a-radio
              value="png"
              id="engraving_setting_labelImageFormat_png_radio"
              ><span id="engraving_setting_labelImageFormat_png_radio_label"
                >png</span
              ></a-radio
            >
          </a-radio-group>
        </div>
        <div class="image-format-box">
          <span id="span_0o85acra9z" class="base-title-label">{{
            $t('cuttingDock.labelingSettings.imgSetting.code')
          }}</span>
          <a-radio-group v-model="formData.labelImageFormatNew">
            <a-radio
              value="png"
              id="engraving_setting_labelImageFormatNew_png_radio"
              ><span id="engraving_setting_labelImageFormatNew_png_radio_label"
                >png</span
              ></a-radio
            >
            <a-radio
              value="jpeg"
              id="engraving_setting_labelImageFormatNew_jpeg_radio"
              ><span id="engraving_setting_labelImageFormatNew_jpeg_radio_label"
                >jpeg</span
              ></a-radio
            >
            <a-radio
              value="bmp"
              v-if="isShowBmpRadio"
              id="engraving_setting_labelImageFormatNew_bmp_radio"
              ><span id="engraving_setting_labelImageFormatNew_bmp_radio_label"
                >bmp（{{
                  $t('cuttingDock.labelingSettings.imgSetting.slowDown')
                }}）</span
              ></a-radio
            >
          </a-radio-group>
          <div
            id="div_6hmkwyzu1i"
            style="margin-left: 246px"
            class="color-o-4 mt4"
          >
            {{ $t('cuttingDock.labelingSettings.imgSetting.codeTip') }}
            <div v-if="isBmpExport" class="mt10">
              <a-radio-group v-model="formData.bmp_color_style">
                <a-radio :value="0" id="engraving_setting_is1bitBmp_radio_false"
                  ><span id="engraving_setting_is1bitBmp_radio_false_label">{{
                    $t('cuttingDock.labelingSettings.imgSetting.color')
                  }}</span></a-radio
                >
                <a-radio :value="1" id="engraving_setting_is1bitBmp_radio_true"
                  ><span id="engraving_setting_is1bitBmp_radio_true_label">{{
                    $t('cuttingDock.labelingSettings.imgSetting.bit')
                  }}</span></a-radio
                >
              </a-radio-group>
            </div>
          </div>
        </div>
        <div class="image-format-box">
          <span id="span_rkidifw97q" class="base-title-label"
            >{{
              $t('cuttingDock.labelingSettings.imgSetting.resolution')
            }}：</span
          >
          <el-input
            :placeholder="
              $t(
                'cuttingDock.labelingSettings.imgSetting.resolutionPlaceholder'
              )
            "
            size="small"
            v-model="formData.label_resolution[0]"
            @input="resolutionChange($event, 0)"
            maxlength="4"
            id="engraving_setting_label_resolution_input_1"
          ></el-input>
          ×
          <el-input
            :placeholder="
              $t(
                'cuttingDock.labelingSettings.imgSetting.resolutionPlaceholder'
              )
            "
            size="small"
            v-model="formData.label_resolution[1]"
            @input="resolutionChange($event, 1)"
            maxlength="4"
            id="engraving_setting_label_resolution_input_2"
          ></el-input>
        </div>
        <div>
          <!-- <m-tag-lake
              :tag-list="tagList"
              :values="formData.label_image_name_type ?? []"
              @onChange="handleTagChange"
            ></m-tag-lake> -->
          <div class="image-format-box flex">
            <span id="span_jce5mts4l8" class="base-title-label"
              >{{
                $t('cuttingDock.labelingSettings.imgSetting.labelImgName')
              }}：</span
            >
            <div>
              <div class="flex">
                <span class="color-o-4">{{ $translateLang('注意') }}：</span>
                <span id="span_01eee7ilzk" class="color-o-4">
                  <div>
                    1、{{
                      $t('cuttingDock.labelingSettings.imgSetting.labelTip1')
                    }}
                  </div>
                  <div id="span_01eee7ilzk_2">
                    2、{{
                      $translateLang(
                        '【标签序号】为开料清单小板从上到下的序列号，排版页添加的小板无此数据'
                      )
                    }}
                  </div>
                  <div id="span_01eee7ilzk_3">
                    {{
                      $t('cuttingDock.labelingSettings.imgSetting.labelTip2')
                    }}！
                  </div>
                </span>
              </div>
              <!-- <a-transfer
                  :data-source="tagList"
                  :titles="['数据标签池', '显示字段']"
                  :target-keys="formData.label_image_name_type ?? []"
                  :lazy="false"
                  :render="(item) => item.title"
                  @change="handleTagChange"
                /> -->
              <m-data-tag
                :is-pdf="false"
                :tag-list="tagList"
                :values="formData.label_image_name_type ?? []"
                @onChange="handleTagChange"
                idKey="labelImageName"
              ></m-data-tag>
            </div>
          </div>
          <div class="image-format-box">
            <span id="span_riyt7o31aw" class="base-title-label"
              >{{
                $t('cuttingDock.labelingSettings.imgSetting.delimiter')
              }}：</span
            >
            <a-input
              class="split-char"
              @input="handleinputSplitChar"
              v-model="formData.label_image_name_separator"
              id="engraving_setting_label_image_name_separator_input"
            ></a-input>
            <div
              id="div_sp1m0zj3b1"
              class="color-a mt4"
              style="margin-left: 246px"
            >
              {{ $t('cuttingDock.labelingSettings.imgSetting.inputTip') }}
            </div>
          </div>
          <div class="image-format-box">
            <span id="span_c2lj15ku2g" class="base-title-label"
              >{{
                $t('cuttingDock.labelingSettings.imgSetting.numStart')
              }}：</span
            >
            <a-input
              id="labellingSetting_start_number_input"
              class="split-char"
              @blur="handleInputBlur"
              @input="handleInputNumber"
              v-model="formData.front_labeling_start_num"
            ></a-input>
          </div>
          <div class="image-format-box">
            <span id="span_h8ahmvsc0h" class="base-title-label"
              >{{
                $t('cuttingDock.labelingSettings.imgSetting.example')
              }}：</span
            >
            <span style="white-space: pre">{{ exampleName }}</span>
          </div>
          <div class="image-format-box">
            <span id="span_bii78errvf" class="base-title-label"
              >{{
                $t('cuttingDock.labelingSettings.imgSetting.stockNumOffset')
              }}：</span
            >
            <a-input-number
              id="stockNum_offset_number_input"
              class="split-char"
              :min="1"
              :max="99"
              :controls="false"
              v-model="formData.stockNumOffset"
              @change="handlerEditStockNumOffset"
            ></a-input-number>
            <span id="span_nf9tfxyze0" class="color-a">{{
              $t('cuttingDock.labelingSettings.paibanImgSetting.figure')
            }}</span>
            <span id="span_e52v8lgiy7" class="color-a"
              >（{{
                $t('cuttingDock.labelingSettings.paibanImgSetting.inputTip')
              }}）</span
            >
          </div>
          <div class="image-format-box">
            <span id="span_3gkbyt24lp" class="base-title-label"
              >{{
                $t('cuttingDock.labelingSettings.imgSetting.divideFolders')
              }}：</span
            >
            <a-switch
              id="labellingSetting_big_plank_folder_checkbox"
              v-model="formData.label_img_big_plank_folder"
              :disabled="obj.label_image_in_nc_folder"
            ></a-switch>
            <div
              id="div_q0zw4y3kgl"
              class="color-a mt4"
              style="margin-left: 246px"
            >
              {{ $t('cuttingDock.labelingSettings.imgSetting.foldersTip1') }}
              <p id="p_8r09hnj9de">
                {{ $t('cuttingDock.labelingSettings.imgSetting.foldersTip2') }}
              </p>
            </div>
          </div>
        </div>
        <div class="image-format-box flex" v-if="!isHideLabelingInsert">
          <span id="span_vk2bghc7iu" class="base-title-label"
            >{{
              $t('cuttingDock.labelingSettings.imgSetting.stickIntoFolders')
            }}：</span
          >
          <div>
            <a-switch
              id="labellingSetting_file_insert_checkbox"
              :disabled="!formData.label_img_big_plank_folder"
              v-model="formData.labeling_file_insert"
            ></a-switch>
            <div id="div_obuinco7gs" class="color-o-4 mt4">
              {{ $t('cuttingDock.labelingSettings.imgSetting.stickTip1') }}
              <p id="p_mywbt5e3s4" class="mb0">
                {{ $t('cuttingDock.labelingSettings.imgSetting.stickTip2') }}
              </p>
              <span id="span_htz8u4l5rc"
                >{{ $t('cuttingDock.labelingSettings.imgSetting.stickTip3') }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="image-format">
        <span id="span_iy93sn90c8" class="head-title">{{
          $t('cuttingDock.labelingSettings.pdfSetting.title')
        }}</span>
        <div>
          <div class="image-format-box flex">
            <span id="span_jce5mts4l8" class="base-title-label"
              >{{
                $t('cuttingDock.labelingSettings.pdfSetting.pdfLabelName')
              }}：</span
            >
            <div>
              <m-data-tag
                :is-pdf="true"
                :tag-list="tagListPdf"
                :values="formData.pdf_label_name ?? []"
                @onChange="handleTagChangePdf"
                idKey="pdfLabelName"
              ></m-data-tag>
            </div>
          </div>
          <div class="image-format-box">
            <span id="span_riyt7o31aw" class="base-title-label"
              >{{
                $t('cuttingDock.labelingSettings.imgSetting.delimiter')
              }}：</span
            >
            <a-input
              class="split-char"
              @input="handleinputSplitCharPdf"
              v-model="formData.pdf_label_name_separator"
              id="engraving_setting_pdf_label_name_separator_input"
            ></a-input>
            <div
              id="div_sp1m0zj3b1"
              class="color-a mt4"
              style="margin-left: 246px"
            >
              {{ $t('cuttingDock.labelingSettings.imgSetting.inputTip') }}
            </div>
          </div>
          <div class="image-format-box">
            <span id="span_h8ahmvsc0h" class="base-title-label"
              >{{
                $t('cuttingDock.labelingSettings.pdfSetting.example')
              }}：</span
            >
            <span style="white-space: pre">{{ exampleNamePdf }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { buryPoint } from '@/apis/common/buryPoint'
import { getEquipmentPermission } from '@/apis/equipment'
import newContent from '@/components/newContent.vue'
import store from '@/store'
import { buryPointFunc } from '@/util/buryPointDeal'
import { verifyInputNumber } from '@/util/commonFuncs'
import { thirdPermission } from '@/util/commonFuncs.js'
import mMachinePos from '@/views/preLayoutSetting/components/m-machine-pos.vue'
import { mapState } from 'vuex'

import MDataTag from './m-data-tag.vue'
import MTagLake from './m-tag-lake.vue'

export default {
  components: {
    MTagLake,
    newContent,
    mMachinePos,
    MDataTag,
  },
  props: {
    obj: {
      type: [Array, Object],
      default: () => ({}),
    },
    paibanImgScale: {
      type: Number,
      default: 2,
    },
    allLabelingList: {
      type: [Array, Object],
      default: () => [],
    },
    labelNotOnline: {
      type: Boolean,
      default: false,
    },
    isShowSecondaryCatalog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
      },
      vv: true,
      fileFormatList: [
        { name: '默认格式', value: 'bluen' },
        { name: '南兴格式', value: 'nanxing' },
        { name: '霍尼韦尔格式', value: 'honeywell' },
        { name: '星辉格式', value: 'xinghui' },
        { name: '豪德格式', value: 'haode' },
        { name: '极东格式', value: 'jidong' },
        { name: '铭雕格式', value: 'mingdiao' },
        { name: '精美格式', value: 'jingmei' },
      ],
      formData: {
        offsetAfterLabelRotation: false,
        xOffsetAfterLabelRotation: '',
        yOffsetAfterLabelRotation: '',
        labelingDodge: true,
        no_gen_labelling_file_to_surplus: false,
        labelingOrder: 'cutOrder',
        label_after_send_stock: false,
        labelOverturn: false,
        labelFormat: '',
        labelXOffset: '',
        labelYOffset: '',
        labelingMachine: false,
        labelImageFormat: '',
        labelImageFormatNew: '',
        label_resolution: [],
        front_labeling_start_num: '0', //贴标序号起始数值
        stockNumOffset: 1, //大板序号补偿位数 默认1位
        label_img_big_plank_folder: false, // 标签图片根据大板分为不同文件夹
        labeling_file_insert: false, // 贴标文件插入到对应大板的贴标图片文件夹中
        label_picture_delimiter: false,
        labelingCountertopSetting: {
          labelingStartPosition: 'bottom_left',
          xDatumSwap: false,
          yDatumSwap: false,
        },
        layoutImageSetting: {
          num_auto_offset: 1,
          layoutImage: [
            {
              enable: false,
              imageDirection: 'horiz',
              imageFormat: 'bmp',
              imageNamePrefix: 'T',
              imageSize: [158, 107],
              way: 1,
            },
            {
              enable: false,
              imageDirection: 'horiz',
              imageFormat: 'bmp',
              imageNamePrefix: 'T',
              imageSize: [158, 107],
              way: 2,
            },
            {
              enable: false,
              imageDirection: 'vert',
              imageFormat: 'bmp',
              imageNamePrefix: 'T',
              imageSize: [793, 1122],
              way: 3,
            },
          ],
        },
        rotateLabelSetting: {
          criticalValue: 80,
          horizontal: 'H',
          rotateLabel: false,
        },
        label_image_name_type: [], // 字段同步后端命名
        label_image_name_separator: '_', //贴标文件分隔符
        pdf_label_name: [], // PDF文件名
        pdf_label_name_separator: '_', // PDF文件名分隔符
        bmp_color_style: 0, //是否为1bit导出
        lable_parallel_setting: {
          parallel_plank: false,
          effective_object: 'notcare',
          parallel_approach: 'parallel_height',
        },
        // 后端使用数量字段要求
        old_label_format: '',
      },
      tagList: [],
      defaulTagValue: {
        address: '订单一',
        orderNo: '220818-154',
        nc_filename: '001_多层实木_T01_18',
        labeling_filename: 'Label_001_多层实木_T01_18',
        plankNum: '6126134567891',
        stockNum: '1',
        priority: '1',
        labelId: '001',
        auto_index: '0',
        customerName: '客户名称',
        firstFolder: '一级文件夹',
      },
      isHideLabelingInsert: false, // 根据是否是默认模板展示
      autoArrangeError: '',
      tagHorSideArr: [
        {
          label: '与小板长边平行',
          value: 'parallel_long',
        },
        {
          label: '与小板短边平行',
          value: 'parallel_short',
        },
        { label: '与小板长度保持平行', value: 'parallel_height' },
        { label: '与小板宽度保持平行', value: 'parallel_width' },
      ],
      labelingOrderList: [
        {
          label: 'cuttingDock.labelingSettings.cuttingLabelOder',
          value: 'cutOrder',
        },
        { label: 'cuttingDock.labelingSettings.labelToUp', value: 'toTop' },
        {
          label: 'cuttingDock.labelingSettings.labelToDown',
          value: 'toBottom',
        },
      ],
      horizontalList: [
        {
          label: 'cuttingDock.labelingSettings.rotateSetting.horizontal',
          value: 'H',
        },
        {
          label: 'cuttingDock.labelingSettings.rotateSetting.vertical',
          value: 'V',
        },
        {
          label: 'cuttingDock.labelingSettings.rotateSetting.either',
          value: 'HV',
        },
      ],
      labelingStartPositions: [
        {
          label: '左上角',
          value: 'top_left',
        },
        {
          label: '左下角',
          value: 'bottom_left',
        },
        {
          label: '右上角',
          value: 'top_right',
        },
        {
          label: '右下角',
          value: 'bottom_right',
        },
      ],
    }
  },
  watch: {
    'formData.layoutImageSetting.num_auto_offset': {
      handler(newVal) {
        if (!newVal) {
          this.formData.layoutImageSetting.num_auto_offset = 1
        }
      },
      deep: true,
      immediate: true,
    },
    obj() {
      if (Object.keys(this.obj).length > 0) {
        this.formData = { ...this.obj, old_label_format: this.obj.labelFormat }
      }
      if (
        this.obj.label_image_in_nc_folder &&
        store.state.userPermissions['label_image_in_nc_folder']
      ) {
        this.formData.label_img_big_plank_folder = false
      }
      // 大板补偿位数默认为1
      if (typeof this.obj.stockNumOffset === 'undefined') {
        this.formData.stockNumOffset = 1
      }
      this.handlerEditStockNumOffset(this.formData.stockNumOffset)
    },
    'formData.labelImageFormat': {
      handler(newVal) {
        // 在贴标图片后缀为jpg，图片编码格式为bmp时，默认将图片编码选择为png
        if (
          (newVal === 'jpg' || newVal === 'png') &&
          this.formData.labelImageFormatNew === 'bmp'
        ) {
          this.formData.labelImageFormatNew = 'png'
        }
      },
      immediate: true,
    },
    ncLabel: {
      handler(val) {
        this.tagList = val
          .filter((v) => v.label_type == 'label_image_info')
          .map((item) => ({
            key: item.label_name,
            title: item.label_name_show,
          }))
      },
    },
    'formData.labelFormat': {
      handler(val) {
        const info = this.allLabelingList.find(
          (item) => item.labelFormat === val
        )
        // 是默认模板
        if (info && info.default_model === 1) {
          this.isHideLabelingInsert = true
          this.labeling_file_insert = false
        } else {
          this.isHideLabelingInsert = false
        }
      },
    },
    'formData.front_labeling_start_num': {
      handler(newVal) {
        if (
          this.formData.label_image_name_type.filter((i) => i === 'auto_index')
            .length
        ) {
          this.defaulTagValue.auto_index = newVal
        }
      },
      immediate: true,
    },
    'formData.yOffsetAfterLabelRotation': {
      handler(val) {
        if (val == 0) {
          this.formData.yOffsetAfterLabelRotation = ''
        }
      },
    },
    'formData.xOffsetAfterLabelRotation': {
      handler(val) {
        if (val == 0) {
          this.formData.xOffsetAfterLabelRotation = ''
        }
      },
    },
  },
  computed: {
    ...mapState(['ncLabel', 'preferencesSetting']),
    ...mapState('equipEnvironment', ['previewInfo']),
    tagListPdf() {
      return [
        {
          key: 'address',
          title: this.$t('cuttingDock.labelingSettings.pdfSetting.address'),
        },
        {
          key: 'orderNo',
          title: this.$t('cuttingDock.labelingSettings.pdfSetting.orderNo'),
        },
        {
          key: 'firstFolder',
          title: this.$t('cuttingDock.labelingSettings.pdfSetting.firstFolder'),
        },
        {
          key: 'customerName',
          title: this.$t(
            'cuttingDock.labelingSettings.pdfSetting.customerName'
          ),
        },
      ]
    },
    labelingStartPosition() {
      const p = this.labelingStartPositions.find(
        (item) =>
          this.formData.labelingCountertopSetting.labelingStartPosition ===
          item.value
      )
      return p ? p.label : '左下角'
    },
    labelingStartPositionTip() {
      let label = this.formData.labelingCountertopSetting.labelingStartPosition
      let tip = ''
      switch (label) {
        case 'top_left':
          tip = '+x，-y'
          break
        case 'top_right':
          tip = '-x，-y'
          break
        case 'bottom_left':
          tip = '+x，+y'
          break
        case 'bottom_right':
          tip = '-x，+y'
          break
      }
      return tip
    },
    // 生成示例
    exampleName() {
      let str = this.formData.label_image_name_type
        ? Array.from(this.formData.label_image_name_type)
            .map((val) => {
              return this.defaulTagValue[val]
            })
            .join(this.formData.label_image_name_separator)
        : ''
      return str
    },
    exampleNamePdf() {
      let str = this.formData.pdf_label_name
        ? Array.from(this.formData.pdf_label_name)
            .map((val) => {
              return this.defaulTagValue[val]
            })
            .join(this.formData.pdf_label_name_separator)
        : ''
      return str
    },
    // 是否导出bmp
    isBmpExport() {
      return (
        this.formData.labelImageFormat == 'bmp' &&
        this.formData.labelImageFormatNew == 'bmp'
      )
    },
    // 标签旋转后偏移必填检测
    checkTagRotateOffset() {
      return (
        this.formData.offsetAfterLabelRotation &&
        (!this.formData.xOffsetAfterLabelRotation ||
          !this.formData.yOffsetAfterLabelRotation)
      )
    },
    isShowBmpRadio() {
      return this.formData.labelImageFormat === 'bmp'
    },
  },
  methods: {
    // 获取设备使用权限
    async enableEngravingPermission(machineSetting, machineKey, machineName) {
      const machine_enable = this.obj?.[machineKey] || false
      let { edition_id } = store.state.userInfo
      const res = await getEquipmentPermission({
        process_id: this.$route.query.setting_id,
        machine: machineName,
        edition_id: edition_id,
        use_machine: machine_enable ? 1 : 0,
      })
      if (res.status === 1) {
        return Boolean(res.data.can_use_num)
      }
      return false
    },
    // 切换贴标机状态 权限校验
    async handleChangeLabelingMachineStatus(checked) {
      // 仅权限校验通过时才允许将 switch 置为 true，无权限时始终为 false
      if (thirdPermission('/labeling')) {
        try {
          const enable = await this.enableEngravingPermission(
            'labelingSetting',
            'labelingMachine',
            'labeling'
          )
          if (!enable) {
            this.$message({
              type: 'info',
              message: `您当前可使用的贴标机生产线条数已用完，如需增加，请联系销售人员`,
              duration: 1500,
              offset: 70,
            })
            this.formData.labelingMachine = false
            return
          }
        } catch (error) {
          // 打印错误
          this.$message({
            type: 'info',
            message: this.$translateLang('获取设备权限失败！'),
            duration: 1500,
            offset: 70,
          })
          console.log(error, 'error')
          this.formData.labelingMachine = false
          return
        }
        this.formData.labelingMachine = checked
      } else {
        this.formData.labelingMachine = false
      }
      // todo 生产线条数
    },
    handleTagChangePdf(values) {
      this.formData.pdf_label_name = values
    },
    handleinputSplitCharPdf() {
      const reg = /[\\<>:|./?*"]/g
      this.formData.pdf_label_name_separator =
        this.formData.pdf_label_name_separator.replace(reg, '')
      if (this.formData.pdf_label_name_separator.length > 10) {
        this.formData.pdf_label_name_separator =
          this.formData.pdf_label_name_separator.slice(0, 10)
      }
    },

    // 切换选择
    handleChangeRadio(e) {
      if (e == 'toTop') {
        buryPointFunc(
          '雕刻机-贴标设置-自动贴标顺序设置-按照排版结果从下往上贴标'
        )
      } else if (e == 'toBottom') {
        buryPointFunc(
          '雕刻机-贴标设置-自动贴标顺序设置-按照排版结果从上往下贴标'
        )
      } else {
        buryPointFunc('雕刻机-贴标设置-自动贴标顺序设置-按照开料顺序贴标')
      }
    },
    // 工位起始点改变
    handleChangeStartPos(val) {
      const p = this.labelingStartPositions.find((item) => item.label === val)
      this.formData.labelingCountertopSetting.labelingStartPosition = p
        ? p.value
        : 'bottom_left'
    },
    // 标签池拖动改变
    handleTagChange(values) {
      this.formData.label_image_name_type = values
    },
    // 输入分隔符
    handleinputSplitChar() {
      // 限制输入特殊符号
      const reg = /[\\<>:|./?*"]/g
      this.formData.label_image_name_separator =
        this.formData.label_image_name_separator.replace(reg, '')
      if (this.formData.label_image_name_separator.length > 10) {
        this.formData.label_image_name_separator =
          this.formData.label_image_name_separator.slice(0, 10)
      }
    },
    // 输入贴标序号起始数值
    handleInputNumber() {
      const reg = /[^0-9]/g
      this.formData.front_labeling_start_num =
        this.formData.front_labeling_start_num.replace(reg, '')
      if (this.formData.front_labeling_start_num.length > 10) {
        this.formData.front_labeling_start_num =
          this.formData.front_labeling_start_num.slice(0, 10)
      }
    },
    // 贴标序号起始数值鼠标失去光标
    handleInputBlur() {
      if (!this.formData.front_labeling_start_num) {
        this.formData.front_labeling_start_num = '0'
      }
    },
    /**
     * @desc 自定义贴标图片名(示例) 跟随 大板序号补偿位数到 动态改变
     * @param data 大板序号补偿位数
     */
    handlerEditStockNumOffset(data) {
      if (!data) return
      // 添加埋点
      buryPoint({
        function_module: 'engraving',
        function_point: 'stockNumOffset',
      })
      let stockNum = this.defaulTagValue.stockNum
      if (this.defaulTagValue.stockNum.length < data) {
        stockNum = stockNum.padStart(data, '0')
      } else {
        stockNum = stockNum.slice(stockNum.length - data, stockNum.length)
      }
      this.defaulTagValue.stockNum = stockNum
    },
    // index为1的时候为宽的值
    paibanImgLimit(item, index) {
      item.imageSize[index] = Number(
        item.imageSize[index].replace(/^(0+)|[^\d]+/g, '')
      )
    },
    // 修改贴标机模板时
    changeLabelingFormat() {
      if (this.formData.labelFormat != '' && this.labelNotOnline) {
        this.$emit('update:labelNotOnline', false)
      }
    },
    resolutionChange(val, key) {
      this.formData.label_resolution[key] = val.replace(/[^\d]/g, '')
    },
    checkInout(val, obj, keys, rule, min) {
      verifyInputNumber(val, obj, keys, rule, false, min)
    },
    // 当旋转生效输入框未输入值时激活输入框
    focusInput() {
      this.$refs['rotateInput']?.focus()
    },
  },
  mounted() {
    this.focusInput()
  },
}
</script>

<style scoped lang="less">
.labelling-setting {
  .head-title {
    display: flex;
    align-items: center;
    background: #fff;
    span {
      margin-right: 16px;
      font-weight: 600;
      font-size: 20px;
    }
  }
  .parallel-effective {
    color: rgba(0, 0, 0, 0.9);
    padding: 24px 0 10px 0;
  }
  .labeling-setting {
    border-bottom: 0px;
  }
  .label-file-format {
    background: #fff;
    .radio-box {
      padding: 24px 24px 16px 24px;
      .all-labeling {
        z-index: 4;
      }
    }
    .not-online-info {
      margin-left: 16px;
      color: #333;
      color: #f00;
      font-size: 14px;
    }
  }
  .auto-feeding-box {
    padding: 24px 24px 16px 24px;
    background-color: #fff;
    .tip {
      color: rgba(0, 0, 0, 0.4);
    }
  }
  .auto-label-setting {
    margin-top: 24px;
    .title {
      padding: 24px;
    }
    .auto-label-tip {
      line-height: 31px;
    }
  }
  .tag-setting {
    background: #fff;
    .head-title {
      .tip {
        margin-right: 10px;
        color: rgba(0, 0, 0, 0.4);
        font-weight: 400;
        font-size: 16px;
        font-style: normal;
      }
    }
    .group {
      display: flex;
      align-items: center;
      padding: 24px 24px 16px 24px;
      .el-input {
        width: 100px;
        margin: 0 10px;
      }
      &/deep/.ant-radio-group {
        margin: 0;
      }
      img {
        margin: 0 40px;
      }
    }
  }
  .XYZ-offset {
    background: #fff;
    .XYZ-offset-box {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 24px;
      & > span {
        color: #8c8c8c;
        font-size: 14px;
      }
      span {
        cursor: default;
      }
      .ant-input {
        width: 83px;
      }
      .x-point {
        margin-right: 40px;
      }
      .y-point {
        margin-right: 24px;
      }
    }
  }
  .image-format {
    background: #fff;
    .image-format-box {
      padding: 24px;
      .el-input,
      .split-char {
        width: 100px;
      }
    }
    .bmp-bit-setting {
      padding-left: 30px;
      :deep(.ant-radio-group) {
        .ant-radio-wrapper {
          span:last-child {
            padding-right: 0;
          }
        }
      }
    }
  }
  .paiban-image {
    background: #fff;
    .paiban-tip {
      color: rgba(0, 0, 0, 0.4);
      font-size: 14px;
      font-weight: normal;
      margin-left: 20px;
    }
    .paiban-image-box {
      padding: 24px;
      > div {
        margin-bottom: 32px;
      }
    }
    .paiban-form-item {
      display: flex;
      margin-bottom: 16px;
      // &:last-child {
      //   margin-bottom: 0;
      // }
      .title {
        display: inline-block;
        flex-shrink: 0;
        width: 92px;
        margin-right: 16px;
        text-align: left;
      }
    }
    .paiban-size {
      .ant-input {
        width: 64px;
      }
    }
  }
  .err-tip {
    top: 45px;
    left: 140px;
    color: red;
  }
}
.auto-arrange-umber {
  padding: 0 24px;
}
.labeling-dodge {
  align-items: center;
  padding: 24px;
}
#labellingSetting_autoArrangeNumber_input {
  width: 64px !important;
}
</style>
